module.exports = __webpack_public_path__ + "img/crc-01.69a35c0e.jpg";